import { createAction, props } from '@ngrx/store';

import {
    AutocompleteExtraLink,
    CategoriesAutocompleteResults,
} from 'SearchApp/ts/types/categories-autocomplete-results.type';
import { AutocompleteResult } from 'SearchApp/ts/interfaces/autocomplete-result.interface';

/**
 * This action is dispatched when a new autocompleter is instantiated.
 */
export const addAutocompleterId = createAction(
    '[Autocompleter] Add Autocompleter ID',
    props<{ autocompleterId: string }>()
);

export const blurAutocompleter = createAction('[Autocompleter] Blur', props<{ autocompleterId: string }>());

export const decrementSelectedIndex = createAction(
    '[Autocompleter] Decrement Selected Index',
    props<{ autocompleterId: string }>()
);

export const focusAutocompleter = createAction('[Autocompleter] Focus', props<{ autocompleterId: string }>());

export const incrementSelectedIndex = createAction(
    '[Autocompleter] Increment Selected Index',
    props<{ autocompleterId: string }>()
);

export const setAutocompleteInputText = createAction(
    '[Autocompleter] Set Input Text',
    props<{ autocompleterId: string; inputText: string; isFetching: boolean }>()
);

export const setAutocompleteListResults = createAction(
    '[Autocompleter] Set List Results',
    props<{ autocompleterId: string; results: AutocompleteResult[] }>()
);

export const setAutocompleteCategoriesResults = createAction(
    '[Autocompleter] Set Categories Results and extra links',
    props<{
        autocompleterId: string;
        results: CategoriesAutocompleteResults;
        extraLinks: AutocompleteExtraLink[];
    }>()
);

export const setAutocompleteDefaultLinks = createAction(
    '[Autocompleter] Set default links',
    props<{
        autocompleterId: string;
        defaultLinks: AutocompleteExtraLink[];
    }>()
);

export const setAutocompleteSelectedIndex = createAction(
    '[Autocompleter] Set Selected Index',
    props<{ autocompleterId: string; selectedIndex: number }>()
);

export const resetAutocompleter = createAction(
    '[Autocompleter] Reset Autocompleter',
    props<{ autocompleterId: string }>()
);

export const setAutocompleteShouldBlur = createAction(
    '[Autocompleter] Set Should Blur',
    props<{ autocompleterId: string; shouldBlur: boolean }>()
);

export const selectResultByIndex = createAction(
    '[Autocompleter] Select Result By Index',
    props<{ autocompleterId: string }>()
);

export const setAutocompleteShowResults = createAction(
    '[Autocompleter] Set Show Results',
    props<{ autocompleterId: string; showResults: boolean }>()
);
